export default {"src":"/_next/static/media/cenz.d81bec2e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};